import BaseLegsTable from '#/components/UnifiedRfqs/components/LegsTable';
import useIsMobile from '@paradigm/design-system/src/hooks/useIsMobile';
import { LegInfoCard } from '#/components/UnifiedRfqs/components/MobileLegsTable';
import { LegTableView } from '@paradigm/features/src/unified-rfqs/ui/types';
import { NEGATIVE_SIGN } from '@paradigm/utils/src/enhanceNegativeSign';

export default function ClosedDrfqLegsTable({
  legs,
}: {
  legs: readonly LegTableView[];
}) {
  const isMobile = useIsMobile();

  return isMobile ? (
    <>
      {legs.map((leg) => (
        <LegInfoCard
          key={leg.index}
          legPricingEnabled={leg.price !== NEGATIVE_SIGN}
          hideMarkPrice
          legPrice={processLegPrice(leg)}
          isTwoWay={false}
          leg={leg}
        />
      ))}
    </>
  ) : (
    <BaseLegsTable side="BUY" legs={legs} />
  );
}

function processLegPrice(leg: LegTableView) {
  return {
    ask: leg.side === 'SELL' ? leg.price : null,
    bid: leg.side === 'BUY' ? leg.price : null,
    displayOnly: true,
    side: 'BUY',
  } as const;
}
